import { combineResolvers, resolveIndividual } from "@helium/anchor-resolvers";
import { PROGRAM_ID } from "./constants";
export const stateControllerProgramResolver = resolveIndividual(async ({ path }) => {
    if (path[path.length - 1] === "stateControllerProgram") {
        return PROGRAM_ID;
    }
});
export const stateControllerResolvers = combineResolvers(stateControllerProgramResolver, resolveIndividual(async ({ path, provider, accounts, programId }) => {
    if (path[path.length - 1] == "proposalProgram" && accounts.proposal) {
        const acct = await provider.connection.getAccountInfo(accounts.proposal);
        return acct.owner;
    }
}));
//# sourceMappingURL=resolvers.js.map